import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  useTheme,
  useMediaQuery,
  Typography
} from "@mui/material";
import { Sex } from '../../../../api/unit/Sex';

// プルダウン定義
const pullDownItems = [
  {
    value: Sex.Women,
    sex: "女性",
  },
  {
    value: Sex.Man,
    sex: "男性",
  }
];

// 読み取り専用フラグ
let isReadOnly = false;

/**
 * 性別選択プルダウン
 *
 * @param inputItem 入力値
 * @param inputRef 入力追跡オブジェクト
 * @returns プルダウン
 */
export const SexPullDown = ({ inputItem, inputRef }: any) => {
  // 入力値をSexオブジェクトに変換
  var inputSexValue = new Sex(inputItem);

  // 入力済みかどうかを判定するフラグ
  isReadOnly = inputSexValue.isAlreadyInput();

  // プルダウンの初期選択値
  const [selectedValue, setSelectedValue] = useState<String>(inputSexValue.getCode());

  useEffect(() => {
    if (inputRef) {
      inputRef.current = selectedValue;
    }
  }, [selectedValue, inputRef]);

  // 選択された値を処理
  const handleSelect = (e: any) => {
    const newValue = e.target.value;
    setSelectedValue(newValue);
    inputSexValue = new Sex(newValue);

    // 親コンポーネントに選択内容を通知
    if (inputRef) {
      inputRef.current = newValue;
    }
  };

  // レスポンシブ対応
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // モバイル用のスタイル適用

  // 読み取り専用の場合、選択済みの内容を表示
  if (isReadOnly) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '4px 8px',
          borderRadius: 1,
          backgroundColor: '#f5f5f5',
          minWidth: '80px',
          justifyContent: 'center',
        }}
      >
        <Typography variant="body1">
          {inputSexValue.toString()}
        </Typography>
      </Box>
    );
  }

  // プルダウン入力フォームを表示
  return (
    <Box sx={{ width: '100%', padding: isMobile ? 1 : 2 }}>
      <FormControl fullWidth>
        <InputLabel id="sex-select-label">性別を選択してください</InputLabel>
        <Select
          labelId="sex-select-label"
          value={selectedValue}
          onChange={handleSelect}
          label="性別"
        >
          {pullDownItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.sex}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
